"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BankAccountValidatorError = /** @class */ (function (_super) {
    __extends(BankAccountValidatorError, _super);
    function BankAccountValidatorError(errors) {
        var _this = _super.call(this, errors.map(function (e) { return e.message; }).join(" ")) || this;
        _this.errors = errors;
        _this.code = errors.map(function (e) { return e.code; }).join(",");
        return _this;
    }
    BankAccountValidatorError.prototype.toString = function () {
        return this.code + this.message;
    };
    return BankAccountValidatorError;
}(Error));
exports.default = BankAccountValidatorError;
//# sourceMappingURL=BankAccountValidatorException.js.map